// extracted by mini-css-extract-plugin
module.exports = {"peers_list":"styles_peers_list__2ycJO","peers_list__compact":"styles_peers_list__compact__N9Fpe","peers_list__nocomments":"styles_peers_list__nocomments__3bpA6"};